import * as React from 'react';
import { Svg } from '../svg';

function SvgForgotPasswordLogo({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="url(#forgot-password-logo_svg__pattern0)"
        d="M.5 0h80v80H.5z"
      />
      <defs>
        <pattern
          id="forgot-password-logo_svg__pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#forgot-password-logo_svg__image0"
            transform="scale(.0125)"
          />
        </pattern>
        <image
          id="forgot-password-logo_svg__image0"
          width={80}
          height={80}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgForgotPasswordLogo);
export default ForwardRef;
